import {DialogTitle} from '@apps-common/ui-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const ShareCollectionCTA = ({open, onClose, collection}) => {
  return (
    <Dialog open={open} size="sm">
      <DialogTitle title="Collection is not shared" onClose={onClose} />
      <DialogContent>
        <DialogContentText>
          {`To allow the organization to access this collection and its related reservations, 
        the owner must share it. Please contact the owner with user ID ${collection.ownership.owner_id} to request sharing.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onClose}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ShareCollectionCTA.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  collection: PropTypes.object,
};

export default ShareCollectionCTA;
